import { ActivityHistoryFilters, State } from '../../typings'

export function fetchAllActivityHistoryFiltersReducer(
  state: State,
  payload: ActivityHistoryFilters,
): State {
  const newState: State = { ...state, filters: payload }

  newState.filters.statusUpdates.filters.forEach((x) => {
    x.isSelected = true
  })

  newState.filters.closingActivities.filters.forEach((x) => {
    x.isSelected = true
  })

  newState.filters.customActivities.filters.forEach((x) => {
    x.isSelected = true
  })

  return newState
}
